import { render } from "./widget-map.vue?vue&type=template&id=16bc47c7&ts=true"
import script from "./widget-map.ts?vue&type=script&lang=ts"
export * from "./widget-map.ts?vue&type=script&lang=ts"

import "./widget-map.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/builds/elichens-avolta-connect/software/avolta-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__